export enum PassengerEligibleEnum {
  eligible = "eligible",
  notEligible = "notEligible",
  eligibleWithLimitations = "eligibleWithLimitations",
}
